export default "__VITE_ASSET__cdfd4e51__"